import { ensureDate } from '@zapier/date';

import { useCurrentAccount, useCurrentUser } from '@zapier/upsells/src/hooks';
import { getTaskUpgradeNudgeEligibility } from './getTaskUpgradeNudgeEligibility';

export const useTaskLimitUpgradeNudges = () => {
  const {
    currentAccount,
    error: currentAccountError,
    isLoading: isLoadingCurrentAccount,
  } = useCurrentAccount();

  const {
    currentUser,
    error: currentUserError,
    isLoading: isLoadingCurrentUser,
  } = useCurrentUser();

  const billingPeriodEndDate = currentAccount?.periodEndDate
    ? ensureDate(currentAccount?.periodEndDate)
    : undefined;

  const billingPeriodStartDate = currentAccount?.periodStartDate
    ? ensureDate(currentAccount?.periodStartDate)
    : undefined;

  const {
    isEligibleForLowTaskUpgradeNudge,
    isEligibleForTaskUpgradeNudge,
  } = getTaskUpgradeNudgeEligibility({ account: currentAccount });

  return {
    billingPeriodEndDate,
    billingPeriodStartDate,
    error: currentAccountError ?? currentUserError,
    isEligibleForLowTaskUpgradeNudge,
    isEligibleForTaskUpgradeNudge,
    isLoading: isLoadingCurrentAccount || isLoadingCurrentUser,
    isMasquerade: currentUser?.isMasquerade,
  };
};
